module.exports = __webpack_public_path__ + "static/media/like.762113f4.svg";